var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var appointmentTabsTemplate = require('./appointmentTabsTemplate.hbs');
var AppointmentUpcomingListWidget = require('./AppointmentUpcomingListWidget');
var AppointmentPastListWidget = require('./AppointmentPastListWidget');
var screenSizeView = require('./../widget/screen-size/screenSizeView');
var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel');

var TAB_NAME_PROPERTY_NAME = 'tabName';
var TAB_NAMES = {
      UPCOMING: 'upcoming',
      PAST: 'past',
      DEFAULT: 'upcoming'
    };

/**
 * Perspective to display the lists of appointments for a patient.
 *
 * @class AppointmentTabsView
 * @constructor
 */
var AppointmentTabsView = TorsoView.extend({
  tagName: 'section',
  className: 'brec-tab__container',
  template: appointmentTabsTemplate,

  events: {
    'click [data-tab-toggle]' : '_toggleTabs'
  },

  prepareFields: {
    tabName: function() {
      return this.get(TAB_NAME_PROPERTY_NAME) || TAB_NAMES.DEFAULT;
    },
    patientVecnaId: '_patientVecnaId',
    TAB_NAMES: TAB_NAMES,
    showTabs: function() {
      var isDefaultScreen = this.get('isDefaultScreen');
      var showTabs = this.get('showTabs');
      return !isDefaultScreen || showTabs;
    }
  },

  injectionSites: {
    'appointment-list': '_getCurrentListWidget'
  },

  /**
   * Detect whether it is in default (not large) screen view
   * @method _updateScreenSize
   * @private
   */
  _updateScreenSize: function() {
    var isDefaultScreen = screenSizeView.currentSizeIsSmaller(screenSizeView.SCREEN_SIZES.MEDIUM_LANDSCAPE);
    this.set('isDefaultScreen', isDefaultScreen);
  },

  /**
   * @method setRouteContext set any context var passed in by the router
   * @param routeParameters {Object} hash of parameter names to values from the route.
   *   @param [routeParameters.tabName='upcoming'] {String} the name of the tab that this perspective should display.
   *                                                Should be one of TAB_NAMES or the default list will be displayed.
   *   @param [routeParameters.page=1] {String} the page of the list view to display.
   */
  setRouteContext: function(routeParameters) {
    var currentListWidget;
    this.set(TAB_NAME_PROPERTY_NAME, routeParameters.tabName);
    currentListWidget = this._getCurrentListWidget();
    if (currentListWidget) {
      currentListWidget.setPage(routeParameters.page);
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} the options of this perspective.
   *   @param [options.patientVecnaId] {String} the patient id of the patient that this perspective is displaying.
   *   @param [options.page=1] {String} the page of the list view to display.
   *   @param [options.tabName='upcoming'] {String} the name of the tab that this perspective should display.
   *                                        Should be one of TAB_NAMES or the default list will be displayed.
   */
  initialize: function(options) {
    var listWidgetOptions = _.pick(options, 'patientVecnaId');
    var routeContext = _.pick(options, 'page', 'tabName');
    var appointmentsUpcomingListView = new AppointmentUpcomingListWidget(listWidgetOptions);

    this._patientVecnaId = options.patientVecnaId;
    this._defaultListView = appointmentsUpcomingListView;
    this._listViews = {};
    this._listViews[TAB_NAMES.UPCOMING] = appointmentsUpcomingListView;
    this.registerTrackedView(this._listViews[TAB_NAMES.UPCOMING]);
    this._listViews[TAB_NAMES.PAST] = new AppointmentPastListWidget(listWidgetOptions);
    this.registerTrackedView(this._listViews[TAB_NAMES.PAST]);
    this.setRouteContext(routeContext);
    this.listenTo(this.viewState, 'change:' + TAB_NAME_PROPERTY_NAME, this._fetchList);
    this.listenTo(this.viewState, 'change', this.render);

    appointmentConfigurationModel.loadOnce();
  },

  /**
   * Retrieves the list associated with the currently selected tab (or the default list if not found).
   * @method _getCurrentListWidget
   * @returns {Torso.View}
   * @private
   */
  _getCurrentListWidget: function() {
    var tabName = this.get(TAB_NAME_PROPERTY_NAME);
    return this._listViews[tabName] || this._defaultListView;
  },

  /**
   * Fetch the list of messages on for the currently selected tab
   * @method _fetchList
   * @private
   */
  _fetchList: function() {
    var currentListWidget = this._getCurrentListWidget();
    currentListWidget.fetchMessages();
  },

  /**
   * @method _attached
   * @override
   * @private
   */
  _attached: function() {
    // Only render when screen size changes if the view is attached.
    this.listenTo(screenSizeView, 'change:screenSize', this._updateScreenSize);
    this._updateScreenSize();
    this.listenTo(appointmentConfigurationModel, 'load-complete', this.render);
  },

  /**
  * @method _detached
  * @override
  * @private
  */
  _detached: function() {
    this.stopListening(screenSizeView);
    this.stopListening(appointmentConfigurationModel, 'load-complete', this.render);
  },

  /**
   * The mobile toggler for the tabs
   * @method _toggleTabs
   * @private
  */
  _toggleTabs: function() {
    var showTabs = this.get('showTabs');
    this.set('showTabs', !showTabs);
  }
});

AppointmentTabsView.TAB_NAMES = TAB_NAMES;

module.exports = AppointmentTabsView;
